import React, { ReactNode } from 'react';
import { PartialSearchingProps, SearchingProps } from 'modules/Shared/type';
import { PageProps } from 'modules/Layout/type';
import { managePageAction, ManagePageAction } from 'modules/Layout/action';
import { Dispatch } from 'redux';
import { breadcrumbRouteNews } from 'modules/News/breadcrumbs';
import { connect } from 'react-redux';
import Listing from 'modules/Layout/component/Listing';
import NewsTable from 'modules/News/container/Table';
import NewsFilter from 'modules/News/container/Filter';
import NewsPagination from 'modules/News/container/Pagination';
import NewsPerPage from 'modules/News/container/PerPage';
import News from 'modules/News/model/News';
import { createSearchingProps } from 'modules/Shared/helper/params';
import {
  setNewsListParamsAction,
  SetNewsListParamsAction
} from 'modules/News/action/List';
import { RootState } from 'app/reducer';
import { Link } from 'react-router-dom';
import { getPathUrl } from 'modules/Shared/helper/api';
import { ROUTE_NEWS_ORDER } from 'modules/News/routes';

export interface StateProps {
  fetching: boolean;
  type: string;
}

export interface DispatchProps {
  managePage: (payload: PageProps) => ManagePageAction;
  setParams: (payload: PartialSearchingProps) => SetNewsListParamsAction;
}

export type Props = StateProps & DispatchProps;

export const mapDispatch = (dispatch: Dispatch): DispatchProps => ({
  managePage: (payload: PageProps) => dispatch(managePageAction(payload)),
  setParams: (payload: PartialSearchingProps) =>
    dispatch(setNewsListParamsAction(payload))
});

export const mapState = (state: RootState): StateProps => {
  const { fetching } = state.news.list;
  const { type } = state.layout.page;

  return { fetching, type };
};

export class NewsListView extends React.Component<Props> {
  protected searchProps: SearchingProps;

  constructor(props: Props) {
    super(props);

    this.searchProps = createSearchingProps(
      window.location.hash,
      News.getFilterableAttributes(),
      News.getSortableAttributes()
    );
  }

  componentDidMount(): void {
    const { managePage, setParams } = this.props;

    managePage({
      title: 'News',
      breadcrumb: breadcrumbRouteNews()
    });

    setParams(this.searchProps);
  }

  render(): ReactNode {
    const { fetching, type } = this.props;
    const { filter } = this.searchProps;

    if (type) return null;
    return (
      <div className="row news-view">
        <div className="col-12">
          <Listing
            table={<NewsTable />}
            filter={<NewsFilter values={filter} />}
            pagination={<NewsPagination />}
            perPage={<NewsPerPage />}
            addBtn={{ text: 'Add news', url: '/news/add' }}
            buttons={[
              <Link
                key="news-order"
                className="btn ml-2 btn-info"
                to={getPathUrl(ROUTE_NEWS_ORDER)}
              >
                Reorder news
              </Link>
            ]}
            loading={fetching}
          />
        </div>
      </div>
    );
  }
}

export default connect<StateProps, DispatchProps>(
  mapState,
  mapDispatch
)(NewsListView);
